export const SDCheckboxOverrides = error => ({
  Root: {
    style: ({ $theme }) => ({
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.5rem',
      alignSelf: 'stretch',
      ':not(:last-child)': {
        marginBottom: '1rem',
      },
    }),
  },
  Checkmark: {
    style: ({ $theme }) => ({
      backgroundSize: 'auto',
      border: error ? `solid 2px ${$theme.colors.borderErrorPink}` : `solid 1px ${$theme.colors.borderInput}`,
      borderRadius: '8px 8px',
      width: '2rem',
      height: '2rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 0,
    }),
  },
  Label: {
    style: ({ $theme }) => ({
      flex: '1 0 0',
      display: 'flex',
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '1.6rem',
      letterSpacing: '-0.011rem',
      marginTop: '0.25rem',
      paddingLeft: 0,
      color: error ? $theme.colors.errorTextAlt : $theme.colors.contentPrimary,
    }),
  },
})
